import { render } from "./NewCostLabel.vue?vue&type=template&id=0eca03d4"
import script from "./NewCostLabel.vue?vue&type=script&lang=js"
export * from "./NewCostLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__